import { productIdFormat } from "@redotech/redo-product-id";
import * as z from "zod";
import { null as zNull } from "zod";

/** `publish: null` clears the override, reverting to the restriction default. */
export const setProductPublishOverride = {
  name: "setProductPublishOverride" as const,
  input: z.object({
    productId: productIdFormat.schema,
    destinationCountryCode: z.string(),
    publish: z.boolean().nullable(),
  }),
  output: zNull(),
};
